import _Vue from "vue";
import PendoService from "./PendoService";

export function PendoServicePlugin(Vue: typeof _Vue): void {
    const pendoService = new PendoService();
    Vue.prototype.$pendo = pendoService;
}
